/* eslint-disable no-unused-expressions */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable import/no-unresolved */
import { memo } from "react";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { FormikErrors, FormikTouched } from "formik";
// import { useDispatch } from "react-redux";
// import { setCovidAndNriDetails } from "src/redux/Actions/common";
import CustomErrorText from "../CustomErrorText";

interface Props {
  className?: string;
  inputClassName?: string;
  label: string;
  name: string;
  setFieldValue: (field: string, value: any) => void;
  touched?: FormikTouched<Date>;
  error?: FormikErrors<string>;
  setFieldTouched: (field: string, touched: boolean) => void;
  requiredStar?: boolean;
  disableField?: boolean;
  // isSaveFlag?: boolean;
  value?: string;
  minDate?: any;
  disableFuture?: boolean;
  maxDate?: any;
}
function CustomDatePicker({
  className,
  inputClassName,
  label,
  name,
  setFieldValue,
  touched,
  error,
  setFieldTouched,
  requiredStar,
  disableField,
  disableFuture,
  minDate,
  // isSaveFlag,
  value,
  maxDate
}: Props) {
  // const dispatch = useDispatch();

  return (
    <div className={className}>
      <div className="rounded-lg border border-solid border-discoBall focus-within:border-2 focus-within:border-hotShot">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            disabled={disableField}
            disableFuture={disableFuture}
            onOpen={() => setFieldTouched(name, true)}
            format="DD/MM/YYYY"
            value={dayjs(value, "DD/MM/YYYY")}
            onChange={(fieldValue: any) => {
              setFieldValue(name, fieldValue ? dayjs(fieldValue).format("DD/MM/YYYY") : "");
              // if (isSaveFlag) {
              //   dispatch(
              //     setCovidAndNriDetails({
              //       field: name,
              //       value: dayjs(fieldValue).format("DD/MM/YYYY")
              //     })
              //   );
              // }
            }}
            minDate={minDate}
            maxDate={maxDate}
            slotProps={{
              inputAdornment: {
                classes: {
                  root: `!mr-0.5 !z-10 !p-3 ${disableField ? "!bg-transparent" : "!bg-white"}`
                }
              },
              actionBar: {
                actions: !["Invalid Date", ""].includes(value || "") ? ["clear"] : []
              },
              textField: {
                variant: "filled",
                disabled: disableField,
                placeholder: "DD/MM/YYYY",
                onBlur: () => setFieldTouched(name, true),
                fullWidth: true,
                required: requiredStar,
                InputProps: {
                  disableUnderline: true,
                  classes: {
                    input:
                      "!text-sm !cursor-pointer !leading-5 !font-medium !text-black !rounded-lg !bg-white !font-montserrat",
                    root: `!mt-0 ${inputClassName}`,
                    adornedEnd: "!bg-transparent !rounded-lg !mr-1",
                    disabled: "!bg-gray-200"
                  }
                },
                InputLabelProps: {
                  classes: {
                    root: "!text-sm !leading-5 !font-medium !text-platinumGranite !pt-0.5 !pb-0.5 !font-montserrat",
                    shrink: "!text-purpleComet !text-xs"
                  }
                }
              }
            }}
            label={label}
          />
        </LocalizationProvider>
      </div>
      {touched && error && <CustomErrorText text={error} type="error" />}
    </div>
  );
}

CustomDatePicker.defaultProps = {
  className: "",
  inputClassName: "",
  requiredStar: false,
  touched: "",
  error: "",
  disableField: false,
  // isSaveFlag: false,
  value: "",
  minDate: "",
  disableFuture: false,
  maxDate: ""
};

export default memo(CustomDatePicker);
